import React from 'react'
import PropTypes from 'prop-types'

const STICKY_CLASS_NAME = 'sticky'

export default function withStickiness(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props)
      this.state = {
        isSticky: false,
        distanceFromTop: null
      }
    }

    componentDidMount() {
      document.addEventListener('scroll', this.handleScroll)
    }

    componentWillUnmount() {
      document.removeEventListener('scroll', this.handleScroll)
    }

    setStickyContainer = (stickyContainer) => this.stickyContainer = stickyContainer
    setOnAddStickiness = (handler) => this.handleAddStickiness = handler
    setOnRemoveStickiness = (handler) => this.handleRemoveStickiness = handler

    addStickiness = () => {
      this.setState({isSticky: true, distanceFromTop: window.pageYOffset})
      this.stickyContainer.classList.add(STICKY_CLASS_NAME)
      this.handleAddStickiness && this.handleAddStickiness()
    }

    removeStickiness = () => {
      this.stickyContainer.classList.remove(STICKY_CLASS_NAME)
      this.setState({isSticky: false, distanceFromTop: null})
      this.handleRemoveStickiness && this.handleRemoveStickiness()
    }

    handleScroll = () => {
      if(!this.stickyContainer) {
        return
      }

      const rect = this.stickyContainer.getBoundingClientRect()

      if(!this.props.shouldStickToTop || (
        !!this.state.distanceFromTop &&
        document.documentElement.scrollTop < this.state.distanceFromTop
      )){
        if(this.state.isSticky) {
          this.removeStickiness()
        }
      }
      else if(rect.top <= 0) {
        if(!this.state.isSticky) {
          this.addStickiness()
        }
      }
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          provideOnAddStickiness={this.setOnAddStickiness}
          provideOnRemoveStickiness={this.setOnRemoveStickiness}
          provideStickyContainer={this.setStickyContainer} />
      )
    }
  }
}

